// src/utils/fontawesome.ts
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
// Importa anche altre librerie se necessario
// import { far } from '@fortawesome/free-regular-svg-icons';
// import { fab } from '@fortawesome/free-brands-svg-icons';

// Aggiungi le librerie di icone alla library globale
library.add(fas);
// library.add(far, fab); // Decommentare se necessario

// Definizione dei tipi per gli oggetti icona
/**
 * Converte una stringa di classe Font Awesome in un oggetto IconLookup
 * @param iconClass - Stringa nel formato "fas fa-house" o "fa-house"
 * @returns IconLookup object o null se l'input non è valido
 */
export const parseIconClass = (iconClass) => {
    if (!iconClass || typeof iconClass !== 'string') return null;

    // Supporta formati "fas fa-house", "fa-house" e "fas fa-house mr-2"
    const parts = iconClass.split(' ');

    let prefix = 'fas'; // Default a solid
    let iconName = '';
    
    // Cerca il prefisso (fas, far, fab, fa-solid, fa-regular, fa-brands) e il nome dell'icona (fa-nome)
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        
        // Verifica se è un prefisso di FontAwesome (formato breve)
        if (part === 'fas' || part === 'far' || part === 'fab') {
            prefix = part;
            continue;
        }
        
        // Verifica se è un prefisso di FontAwesome (formato lungo)
        if (part === 'fa-solid') {
            prefix = 'fas';
            continue;
        } else if (part === 'fa-regular') {
            prefix = 'far';
            continue;
        } else if (part === 'fa-brands') {
            prefix = 'fab';
            continue;
        }
        
        // Verifica se è un nome di icona (inizia con fa-)
        if (part.startsWith('fa-')) {
            iconName = part.replace(/^fa-/, '');
            break; // Abbiamo trovato l'icona, possiamo fermarci
        }
    }
    
    // Se non abbiamo trovato un nome di icona, proviamo a usare il secondo elemento
    // per compatibilità con il vecchio formato "fas fa-house"
    if (!iconName && parts.length >= 2) {
        iconName = parts[1].replace(/^fa-/, '');
    }

    return {
        prefix,
        iconName
    };
};